var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 8L8 14.667l-.953-.954 5.047-5.046H1.334V7.333h10.76L7.047 2.287 8 1.333 14.667 8z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjY2NjYgNy45OTk3MUw4LjAwMDM1IDE0LjY2NjdMNy4wNDcwNCAxMy43MTM0TDEyLjA5MzcgOC42NjY3NUwxLjMzMzMxIDguNjY2NzVMMS4zMzMzMSA3LjMzMzQxTDEyLjA5MzcgNy4zMzM0Mkw3LjA0NzAyIDIuMjg2NzJMOC4wMDAzMyAxLjMzMzQyTDE0LjY2NjYgNy45OTk3MVoiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";
export { SvgArrowIcon as ReactComponent };